import React, { useRef } from 'react'
import { Box, Text, keyframes, useDimensions } from '@gazin/ecommerce-ui'
import { ProductApi } from 'src/types'

import { ProductsPickUpSlide } from './components/products-pickup-slide'

type ProductSectionProps = {
  darkTheme?: boolean
  products: ProductApi[]
  title: string
  subtitle?: string
}

export const PickUpSection = ({
  darkTheme = false,
  products,
  title,
  subtitle,
}: ProductSectionProps) => {
  const elementRef = useRef<HTMLDivElement>(null)
  const dimensions = useDimensions(elementRef, true)

  const fade = keyframes`from {opacity:0}to {opacity: 1}`
  const fadeAnimation = `${fade}  0.7s`

  return (
    <Box
      animation={fadeAnimation}
      as="section"
      bgColor="white"
      flex="1"
      id="carousel-related-products"
      mb="1rem"
      mt="2rem"
      ref={elementRef}
    >
      {products && (
        <>
          <Text
            as="h2"
            color={darkTheme ? 'neutral.0' : 'neutral.800'}
            fontSize={['1rem', '1.5rem', '1.625rem']}
            fontWeight="600"
            marginBottom="0.5rem"
          >
            {title}
          </Text>
          {subtitle && (
            <Text
              as="p"
              color={darkTheme ? 'neutral.0' : 'neutral.600'}
              fontSize={{ base: '.875rem', md: '1.125rem' }}
              fontWeight="400"
              display="block"
            >
              {subtitle}
            </Text>
          )}
          <ProductsPickUpSlide
            maxWidth={dimensions?.contentBox.width}
            products={products}
          />
        </>
      )}
    </Box>
  )
}
